import { Injectable } from '@angular/core';
import { Nodo } from './nodo';
import { TotemService } from '../totem.service';
import { TotemConfiguracion } from '../totem-configuracion';

// import * as paper from 'paper';
// import * as $ from 'jquery';
declare const $;
// declare const Velocity;
declare const paper;

@Injectable({
  providedIn: 'root'
})
export class AnimateMapService {

  public nodos: any[];
  public ListaInstrucciones: any[] = [];
  public loading = true;
  public propiedadesMapa = {
    orientacion: 0,
    anguloOrientacion: 0,
    ancho: 0,
    alto: 0,
    zoom: 1,
    anchoReal: 0,
    altoReal: 0,
    modo: 0,
    pisoActivo: '',
    rutaActiva: false,
    indicador: null,
  };

  public nodoTotem: any;
  private tiposAccesos: Array<any>;
  private path;
  private mapArrow;
  

  constructor(private totemService: TotemService) { }

  public async initMap(totemConfig: TotemConfiguracion, zoomIn = true): Promise<void> {

    this.propiedadesMapa.orientacion = totemConfig.orientacionId;
    this.propiedadesMapa.anguloOrientacion = totemConfig.anguloOrientacion;

    console.log('[PROPIEDADES MAPA]', this.propiedadesMapa);

    if (!this.propiedadesMapa.ancho) {
      this.propiedadesMapa.ancho = $('#canvas-mapa').innerWidth();
      this.propiedadesMapa.alto = $('#canvas-mapa').innerHeight();
    }

    console.log('MEDIDAS', this.propiedadesMapa.ancho, this.propiedadesMapa.alto);

    await this.setNodos();
    console.log('[TOTEM CONFIG] animate', totemConfig);
    this.setNodoTotem(totemConfig.nodoId);
    this.setActiveFloor(this.nodoTotem.numero_piso);

    const xCoord = this.nodoTotem.posicionx;
    const yCoord = this.nodoTotem.posiciony;

    let duration = 0;
    let delay    = 0;

    const noShake = true;

    // await this.showFloor(this.propiedadesMapa.pisoActivo, noShake);

    if (!this.propiedadesMapa.altoReal) {
      const src = $('.screen-layer-1 img').first().attr('src');
      const imgSize = await this.getRealImgSize(src);

      this.propiedadesMapa.anchoReal = imgSize.width;
      this.propiedadesMapa.altoReal  = imgSize.height;
    }

    console.log('MEDIDAS IMG', this.propiedadesMapa.anchoReal, this.propiedadesMapa.altoReal);

    // const canvas = document.querySelector('#canvas-mapa');
    // Inicio de PaperJS
    paper.setup(document.getElementById('canvas-mapa'));

    const x = this.escalarX(xCoord);
    const y = this.escalarY(yCoord);

    $('.screen').velocity({
      opacity: 1
    }, 100);

    duration = 100;
    delay    = 50;

    if (zoomIn) {
      this.propiedadesMapa.zoom = 1.2;

      await this.centreOn(x, y, this.propiedadesMapa.zoom, duration, delay);
      await this.showTotemPin();
    } else {
      await this.centreOn(x, y, this.propiedadesMapa.zoom, duration, delay);
      await this.showTotemPin();
      await this.delay(1500);
    }

  }

  public async initMapTotem(totemConfig: TotemConfiguracion, zoomIn = true): Promise<void> {

    this.propiedadesMapa.orientacion = totemConfig.orientacionId;
    this.propiedadesMapa.anguloOrientacion = totemConfig.anguloOrientacion;

    console.log('[PROPIEDADES MAPA]', this.propiedadesMapa);

    this.propiedadesMapa.ancho = $('#canvas-mapa').innerWidth();
    this.propiedadesMapa.alto = $('#canvas-mapa').innerHeight();

    // await this.setNodos();
    console.log('[TOTEM CONFIG] animate', totemConfig);

    const xCoord = this.nodoTotem.posicionx;
    const yCoord = this.nodoTotem.posiciony;

    let duration = 0;
    let delay    = 0;

    const noShake = true;
    await this.showFloor(this.propiedadesMapa.pisoActivo, noShake);

    if (!this.propiedadesMapa.altoReal) {
      const src = $('.screen-layer-1 img').first().attr('src');
      const imgSize = await this.getRealImgSize(src);
      this.propiedadesMapa.altoReal  = imgSize.height;
      this.propiedadesMapa.anchoReal = imgSize.width;
    }
    const x = this.escalarX(xCoord);
    const y = this.escalarY(yCoord);

    $('.screen').velocity({
      opacity: 1
    }, 1000);

    duration = 1000;
    delay    = 500;

    if (zoomIn) {
      this.propiedadesMapa.zoom = 1.2;

      await this.centreOn(x, y, this.propiedadesMapa.zoom, duration, delay);
      await this.showTotemPin();
    }

  }

  async reiniciar(zoomIn = true): Promise<any> {
    const xCoord = this.nodoTotem.posicionx;
    const yCoord = this.nodoTotem.posiciony;

    const x = this.escalarX(xCoord);
    const y = this.escalarY(yCoord);

    const duration = 1000;
    const delay    = 500;

    if (zoomIn) {
      this.propiedadesMapa.zoom = 1.2;

      await this.centreOn(x, y, this.propiedadesMapa.zoom, duration, delay);
      await this.showTotemPin();
    } else {
      await this.centreOn(x, y, this.propiedadesMapa.zoom, duration, delay);
      await this.showTotemPin();
      await this.delay(1500);
    }
  }

  private async setNodos(): Promise<any> {
    const response = await this.totemService.getNodos().toPromise();
    console.log('[GET NODOS]', response);

    const nodos = response;
    this.nodos = nodos.filter((nodo) => {
      return nodo.orientacion === this.propiedadesMapa.orientacion;
    });
  }

  private setNodoTotem(id): void {
    // console.log('los nodos',this.nodos, 'y el id',id);
    this.nodoTotem = this.nodos.find((nodo) => {
      return nodo.nod_id === id;
    });
  }

  private setActiveFloor(floor) {
    this.propiedadesMapa.pisoActivo = floor < 0
    ? 'b' + Math.abs(floor) + '-' + this.propiedadesMapa.orientacion
    : 'p' + floor + '-' + this.propiedadesMapa.orientacion;
  }

  public getActiveFloor(nominal: boolean) {
    if (nominal) {
      let floor = this.propiedadesMapa.pisoActivo.replace('-' + this.propiedadesMapa.orientacion, '');
      floor = floor.replace('b', '-');
      floor = floor.replace('p', '');

      return Number(floor);
    }

    return this.propiedadesMapa.pisoActivo;
  }

  public async showFloor(floor, noShake = true, acceso?) {
    // $('.tools-map li button').attr('disabled', 'true');

    const data = await this.floorControl(floor, noShake, acceso);
    // Se gatilla evento para indicar que se está mostrando el piso activo
    $('.screen-wrapper').trigger({type: 'floor-showed', id: floor});

    // Se activa el piso
    this.propiedadesMapa.pisoActivo = data.id;
    console.log('SET PISO ACTIVO', this.propiedadesMapa.pisoActivo);

    // Seteo de indicador de piso
    $('.nav-link').removeClass('active');
    $('.floor-indicator').children().removeClass('active');
    $('.floor-indicator #' + data.id.replace('-' + this.propiedadesMapa.orientacion, '')).addClass('active');
    $('.nav-link#' + data.id.replace('-' + this.propiedadesMapa.orientacion, '')).addClass('active');

    // Se muestra el TotemPin
    if (this.propiedadesMapa.ancho !== 1 && this.propiedadesMapa.alto !== 1) {
      this.showTotemPin();
    }

    // $('.tools-map li button').removeAttr('disabled');

    return data;
  }

  private async floorControl(floor, noShake, acceso): Promise<{ id: string, change: boolean }> {

    return new Promise(async (resolve) => {
      const timer    = null;
      const duration = 1500;
      const delay    = 1000;
      const newIndex = $('[id*=planta]:not([id=planta-mapa])').index($('#planta-' + floor));
      const oldIndex = $('[id*=planta]:not([id=planta-mapa])').index($('#planta-' + this.propiedadesMapa.pisoActivo));
      const transformOrigin = '50% 50%';

      if (newIndex !== oldIndex) {
        // Se limpia el piso actual
        await this.resetFloor();
      }

      if (newIndex < oldIndex) {
        if (acceso) {
          await this.showPopupCambioPiso(acceso, 'down', 2000);
          await this.resetFloor();
          await this.goDown(floor, oldIndex, duration, delay, transformOrigin);

          // await this.delay(delay);
          resolve ({ id: floor, change: true });
        } else {
          await this.goDown(floor, oldIndex, duration);
          // await this.delay(delay);
          resolve ({ id: floor, change: true });
        }
      } else if (newIndex > oldIndex) {
        if (acceso) {
          await this.showPopupCambioPiso(acceso, 'up', 2000);
          await this.resetFloor();
          await this.goUp(floor, oldIndex, duration, delay, transformOrigin);

          // await this.delay(delay);
          resolve ({ id: floor, change: true });
        } else {
          await this.goUp(floor, oldIndex, duration);
          // await this.delay(delay);
          resolve ({ id: floor, change: true });
        }
      } else if (newIndex === oldIndex) {
        if (!noShake) {
          $(`#planta-${this.propiedadesMapa.pisoActivo}`).velocity('callout.shake');
        }

        if ($(`#planta-${this.propiedadesMapa.pisoActivo}`).hasClass('no-visible')) {
          $(`#planta-${this.propiedadesMapa.pisoActivo}`).velocity('transition.slideDownBigIn');
          $(`#planta-${this.propiedadesMapa.pisoActivo}`).removeClass('no-visible');
          await this.delay(delay);
        }

        resolve ({ id: floor, change: false });
      }
    });
  }

  public resetFloor() {

    // Se eliminan los pines y sombras
    $('.screen-layer-3').children().remove();

    // Se elimina la ruta
    this.resetRoute();
  }

  private async goUp(floor, oldIndex, duration = 1000, delay = 0, transformOrigin = '50% 50%'): Promise<any> {

    return new Promise(async (resolve) => {
      const elements = $('[id*=planta]:not([id=planta-mapa])');
      console.log('ELEMENTS', elements);

      let index = -1;
      for (const element of elements) {
        index++;
        console.log('Element', element.id);

        // Se omite pisos inferiores
        if (index < oldIndex) {
          console.log('SE OMITE', element.id);
          continue;
        }

        // Cuando se llega al piso a mostrar se termina
        if (element.id === 'planta-' + floor) {
          console.log('LLEGÓ AL PISO', floor);
          $(element).velocity('transition.floorDownIn');
          await this.delay(duration);
          resolve();
          return;
        }

        $(element).velocity('transition.floorDownOut');
        await this.delay(duration / 2);
      }
    });
  }

  private async goDown(floor, oldIndex, duration = 1000, delay = 0, transformOrigin = '50% 50%'): Promise<any> {

    return new Promise(async (resolve) => {
      const elements = $('[id*=planta]:not([id=planta-mapa])').get().reverse();

      let index = elements.length;
      for (const element of elements) {
        index--;
        console.log('Element', element.id);

        // Se omite pisos superiores
        if (index > oldIndex) {
          continue;
        }

        // Cuando se llega al piso a mostrar se termina
        if (element.id === 'planta-' + floor) {
          $(element).velocity('transition.floorUpIn');
          await this.delay(duration);
          resolve();
          return;
        }

        $(element).velocity('transition.floorUpOut');
        await this.delay(duration / 2);
      }
    });
  }

  private async scrollTo(x: number, y: number, duration = 1000, delay = 0): Promise<void> {

    // console.log('SCROLL TO', x, y);

    const screenHalfX = ($('.screen').outerWidth()  / 2) * 1;
    const screenHalfY = ($('.screen').outerHeight() / 2) * 1;

    let scrollToX = 0;
    let scrollToY = 0;

    const fixX = 0;
    const fixY =  0;

    scrollToX = ((x + fixX) - screenHalfX) * this.propiedadesMapa.zoom;
    scrollToY = ((y + fixY) - screenHalfY) * this.propiedadesMapa.zoom;

    return new Promise((resolve, reject) => {
      if (!x || !y) {
        resolve();
        return;
      }
      $('.screen').animate({
        scrollLeft: scrollToX,
        scrollTop : scrollToY
      }, duration, async () => {
        await this.delay(delay);
        resolve();
      });
    });
  }

  private async zoomIn(duration = 1500, delay = 0, scale = 1.5): Promise<void> {

    return new Promise((resolve, reject) => {
      $('.screen .screen-wrapper').velocity({
        scale,
        transformOrigin: '50% 50%',
      }, {
        delay,
        duration,
        complete: () => {
          resolve();
        }
      });
    });
  }

  private async zoomOut(duration= 1500, delay = 0): Promise<void> {

    return new Promise((resolve, reject) => {
      $('.screen .screen-wrapper').velocity('reverse', {
        duration,
        delay,
        complete: () => {
          resolve();
        }
      });
    });
  }

  public async centreOn(x, y, zoom, duration = 1500, delay = 0): Promise<void> {
    console.log('CENTRE ON', x, y);
    this.scrollTo(x, y, duration, delay);
    await this.zoomIn(duration, delay * 2, zoom);
  }

  public async showPin(node: any, html, times = 10): Promise<void> {
    // No se anima si es que se encuentra dentro del mapa
    if ($('#acceso-' + node.nod_id).length !== 0 && $('#acceso-' + node.nod_id + ':visible').length !== 0) {
     return;
    }

    $('.screen-layer-3').append(html);
    $('.screen-layer-3').append('<div class="shadow-pin" id="shadow-' + node.nod_id + '"></div>');

    // console.log('el nodo', $('#acceso-' + node.nod_id));

    const pinWidth  = $('#acceso-' + node.nod_id).outerWidth(true);
    const pinHeight = $('#acceso-' + node.nod_id).outerHeight(true);

    const shadowWidth  = $('#shadow-' + node.nod_id).outerWidth(true);
    const shadowHeight = $('#shadow-' + node.nod_id).outerHeight(true);

    const posX = this.escalarX(node.posicionx - (shadowWidth / 2));
    const posY = this.escalarY(node.posiciony - shadowHeight - 1);
    // console.log('posiciones',posX,posY)
    $('#acceso-' + node.nod_id).css('left', posX - pinWidth / 6);
    $('#acceso-' + node.nod_id).css('top', posY - pinHeight - 10);

    $('.shadow-pin#shadow-' + node.nod_id).css('left', posX);
    $('.shadow-pin#shadow-' + node.nod_id).css('top', posY);

    await this.animatePin(node.nod_id, times);

  }

  private async showTotemPin(): Promise<void> {
    // Evita que se muestre el Pin del Totem en otro lugar que no sea su piso
    const nominal = true;
    if (this.nodoTotem.piso !== this.getActiveFloor(nominal)) {
      return;
    }

    const node  = this.nodoTotem;
    const html  = '<img width="90" height="90" id="acceso-' + node.nod_id + '" data-id="' + node.nod_id + '" src="img/icon-pin.svg">';
    const times = 1;
    const data = await this.showPin(this.nodoTotem, html, times);

    return data;
  }

  private async animatePin(id, times): Promise<void> {
    return new Promise((resolve, reject) => {
      $('#acceso-' + id)
        .velocity({ opacity: [1, 'easeInSine', 0] }, { duration: 900 })
        .velocity({ translate: [-15, 'easeInOutQuad'] }, {
          loop: times,
          duration: 300,
          complete: () => {
            $(this).addClass('showed');
            resolve();
          }
        });

      $('.shadow-pin#shadow-' + id)
        .velocity({ opacity: [1, 'easeInSine', 0] }, { duration: 900 })
        .velocity({ scale: [0, 'easeInSine', 2] }, {
          loop: times,
          duration: 300
        });
    });
  }

  public escalarX(num: number) {
    const relacion = this.propiedadesMapa.ancho / this.propiedadesMapa.anchoReal;
    // console.log('Ancho', this.propiedadesMapa.ancho);
    // console.log('Alto', this.propiedadesMapa.alto);
    // console.log('Ancho real', this.propiedadesMapa.anchoReal);
    // console.log('Alto real', this.propiedadesMapa.altoReal);
    return num * relacion;
    // return num;
  }

  public escalarY(num: number) {
    const relacion = this.propiedadesMapa.alto / this.propiedadesMapa.altoReal;
    return num * relacion;
    // return num;
  }

  public resetRoute() {
    if (paper.view) {
      paper.view.onFrame = null;
    }

    // Hay una ruta dibujada en el plano
    if (this.path) {
      this.path.clear();
    }

    // Se elimina la flecha de ruta
    if (this.mapArrow) {
      this.mapArrow.remove();
      this.mapArrow = null;
      console.log('map arrow2',this.mapArrow)
    }

    this.propiedadesMapa.rutaActiva = false;
  }

  public async drawRoute(nodes): Promise<void> {
    // Se eliminan las instrucciones pasadas
    // $('.instrucions-ways .instrucciones p').remove();

    // Se elimina alguna ruta que quede
    await this.resetRoute();

    // Se indica que hay una nueva ruta activa
    this.propiedadesMapa.rutaActiva = true;

    const duration = 1000;
    const x = this.nodoTotem.x;
    const y = this.nodoTotem.y;

    console.log('[TOTEM_NODO]', this.nodoTotem);

    await this.scrollTo(this.escalarX(x), this.escalarY(y), duration);
    // console.log('[DRAW ROUTE]', nodes);
    const nodesByFloor = [];
    let piso         = '';
    let index        = -1;
    nodes.forEach((item) => {
      // Se crea el nodo
      const node = {
        point      : new paper.Point(item.node.posicionx, item.node.posiciony),
        acceso     : item.route.tac_id,
        numero_piso: item.node.numero_piso
      };

      // const node = new Nodo(item.node);

      if (Number(piso) !== item.node.numero_piso) {
        piso = item.node.numero_piso;
        index++;
        if (nodesByFloor[index] === undefined) {
          nodesByFloor[index] = [];
        }
      }

      nodesByFloor[index].push(node);
    });

    await this.nodesFloorByFloor(nodesByFloor, 0);

    // Se indica que no hay una ruta activa
    this.propiedadesMapa.rutaActiva = false;

    console.log('[ACTIVE ROUTE?]', this.propiedadesMapa.rutaActiva);

    // Se emite evento para indicar que se terminó la ruta
    $('.screen-wrapper').trigger('route-finished');

    // Se vuelven a habilitar los botones de rutas
    $('.container-transportes button').prop('disabled', false);

    await this.removeMapArrow();
  }

  private nodesFloorByFloor(nodesByFloor, index): Promise<void> {

    return new Promise(async (resolve, reject) => {
      if (!nodesByFloor[index]) {
        console.log('No hay más nodos');
        resolve();
      } else {
        console.log('NODES FLOOR BY FLOOR', nodesByFloor[index]);

        let angulo = 0;
        const pto0 = { x: 0, y: 0 };
        const pto1 = { x: 0, y: 0 };

        const numeroPiso = nodesByFloor[index][0].numero_piso;
        const floor      = numeroPiso < 0 ? 'b' + Math.abs(numeroPiso) : 'p' + numeroPiso;

        // console.log('Numero PISO', nodesByFloor[index]);

        if ($('#planta-' + floor + '-' + this.propiedadesMapa.orientacion).length === 0) {
          console.error('ID floor: ' + floor + '-' + this.propiedadesMapa.orientacion + '  doesn`t exists!');
          resolve();
        }

        // Proximo nodo
        const acceso = nodesByFloor[index-1] ? nodesByFloor[index-1][nodesByFloor[index-1].length -1] : null;
        // console.log('DEBERIA MOSTRAR POPUP SI NO ES NULL: ', acceso);

        console.log('SHOW FLOOR', acceso);
        const data = await this.showFloor(floor + '-' + this.propiedadesMapa.orientacion, true, acceso);

        pto0.x = nodesByFloor[index][0].point.x;
        pto0.y = nodesByFloor[index][0].point.y;

        if (nodesByFloor[index][1]) {
          pto1.x = nodesByFloor[index][1].point.x;
          pto1.y = nodesByFloor[index][1].point.y;

          angulo = this.calcAngle(pto0, pto1);
        }

        console.log('Angulo de cambio de piso', angulo);

        // if (data.change) {
        //   await this.hidePopupCambioPiso();
        // }

        await this.animateRoute(nodesByFloor[index], angulo);
        await this.delay(300);
        await this.nodesFloorByFloor(nodesByFloor, ++index);
        resolve();
      }
    });
  }

  private async animateRoute(nodes, newAngle): Promise<any> {
    return new Promise((resolve) => {

      let otherNodo = [];
      nodes.forEach((element, i: number) => {
        if(nodes[i].point.x !==0 && nodes[i].point.y !==0){
          otherNodo.push(nodes[i]);
        }
      });
      nodes = otherNodo;
      // nodes = nodes.filter(nodo => {
      //   console.log('nodo.x',nodo, nodo.x)
      //   if(nodo.x !==0 && nodo.y !==0){return nodo}
      // })
      // console.log('NODES', nodes);
      this.propiedadesMapa.rutaActiva = true;

      this.path             = new paper.Path({ selected: false });
      this.path.strokeColor = '#fd7e14'; // '#ABABAB';//'#e9004b';//'#FC7E00';
      // this.path.dashArray   = [5, 5];
      this.path.strokeWidth = 3;
      this.path.strokeCap   = 'round';
      this.path.strokeJoin  = 'round';
      // this.path.dashArray = [8, 12];

      // Escalar lo puntos según proporción
      nodes.forEach((element, i: number) => {
        // console.log('============== ORI =============');
        // console.log('x', nodes[i].x);
        // console.log('y', nodes[i].y);

        nodes[i].x = this.escalarX(nodes[i].point.x);
        nodes[i].y = this.escalarY(nodes[i].point.y);

        // console.log('============== MOD =============');
        // console.log('x', nodes[i].x);
        // console.log('y', nodes[i].y);
      });

      const index  = 0;
      const puntos = this.calcWaypoints(nodes);

      // Sólo para tener la variable en local
      const path        = this.path;
      let angulo        = 0;
      let diff          = 0;
      let ANGULO_ORIGEN = newAngle !== undefined ? newAngle : this.propiedadesMapa.anguloOrientacion;

      const pto0 = { x: 0, y: 0 };
      const pto1 = { x: 0, y: 0 };

      const direccion = { instruccion: null, img: '' };

      const duration  = 0;

      console.log('PUNTOS', puntos);

      if (puntos[index]) {
        pto0.x = puntos[index].x;
        pto0.y = puntos[index].y;

        pto1.x = puntos[index + 1].x;
        pto1.y = puntos[index + 1].y;

        // Init de mapArrow
        this.mapArrow = new paper.Raster('assets/img/arrow.svg');

        const angle = this.calcAngle(pto0, pto1);
        this.mapArrow.rotate(angle);

        let i = 0;
        // Animación
        paper.view.onFrame = async (event) => {
          this.mapArrow.size = new paper.Size(20, 20);
          // console.log(event.count);
          // console.log(event.time);
          // console.log(event.delta);

          if (i < puntos.length - 1) {
          // console.log('index', i);

            pto0.x = puntos[i].x;
            pto0.y = puntos[i].y;

            pto1.x = puntos[i + 1].x;
            pto1.y = puntos[i + 1].y;

            angulo = this.calcAngle(pto0, pto1);

            // Se toma el ángulo de diferencia que indica para dónde doblar
            diff = angulo - ANGULO_ORIGEN;

            if (diff !== 0) {
              // console.log('[angulo cambio piso]', diff);

              this.mapArrow.rotate(diff);
              ANGULO_ORIGEN = angulo;
            }

            if (diff !== 0 && Math.abs(diff) > 40 && Math.abs(diff) < 320) {

              // console.log('Pt1: ', pto1);
              // console.log('Pt0: ', pto0);

              // console.log('Ángulo: ', angulo, 'Ángulo Origen: ', ANGULO_ORIGEN, 'Diff', diff);
              // console.log('Nodo', i , 'a', i + 1);

              // Seteo nueva dirección
              // ANGULO_ORIGEN = angulo;

              switch (true) {

                case diff >= 300 && diff <= 330  || diff <= -30 && diff >= -60 :
                  direccion.instruccion = 'gireLeveIzq';
                  direccion.img         = 'assets/img/arrow-soft-left.png';
                  break;

                case diff <= -300 && diff >= -330  || diff >= 30 && diff <= 60 :
                  direccion.instruccion = 'gireLeveDer';
                  direccion.img         = 'assets/img/arrow-soft-right.png';
                  break;

                case diff >= 60 && diff <= 120 :
                  direccion.instruccion = 'gireDer';
                  direccion.img         = 'assets/img/arrow-right.png';
                  break;

                case diff <= -60 && diff >= -120 :
                  direccion.instruccion = 'gireIzq';
                  direccion.img         = 'assets/img/arrow-left.png';
                  break;

                default:
                  direccion.instruccion = null;
              }

              if (direccion.instruccion !== null) {
                console.log('añadir instruccions',direccion);
                this.addInstruction(direccion);
              }
            }

            // console.log('punto ' + i + ' x: ' + puntos[i].x + ' y: '+ puntos[i].y);

            // Se dibuja la línea
            path.lineTo(puntos[i].x, puntos[i].y);
            // path.smooth(); // Suavizado de la ruta, pero afecta el rendimiento

            // Se mueve la flecha
            this.moveMapArrow(puntos[i].x, puntos[i].y);

            // Se mueve mapa con la ruta
            // $('.screen').animate(
            //     {
            //         scrollLeft: puntos[i].x + this.offset.x,
            //         scrollTop : puntos[i].y + this.offset.y
            //     }, 1
            // );

            // console.log(' this.scrollTo(x, y, duration)', scrollToX, scrollToY);
            await this.scrollTo(puntos[i].x, puntos[i].y, duration);

            i++;
          } else {
            paper.view.onFrame = null;
            this.mapArrow.remove();
            resolve();
          }
        };
      } else {
        resolve();
      }
    });
  }

  private calcWaypoints(nodes) {
    const waypoints = [];

    for (let i = 1; i < nodes.length; i++) {
      const pt0 = nodes[i - 1];
      const pt1 = nodes[i];
      const dx  = pt1.x - pt0.x;
      const dy  = pt1.y - pt0.y;

      let hipotenusa = Math.round(Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)));
      // console.log('pt0', pt0);
      // console.log('pt1', pt1);
      // console.log('dx', dx);
      // console.log('dy', dy);
      // console.log('HIPO', hipotenusa);

      // if (MAP_VEL <= 0) {
        // MAP_VEL = 1;
      // }

      const MAP_VEL = 2;
      hipotenusa /= MAP_VEL;

      for (let j = 0; j < hipotenusa; j++) {
        const x = pt0.x + ((dx * j) / hipotenusa);
        const y = pt0.y + ((dy * j) / hipotenusa);
        if(x !== 0 && y !==0){
          waypoints.push({x, y});
        }
      }
    }

    console.log('WAYPOITNS', waypoints);
    return waypoints;
  }

  private calcAngle(pto0, pto1) {
    let angulo   = 0;
    let radianes = 0;

    // ANGULOS:
    // N: 90
    // O: 180
    // S: 270
    // E: 0

    // var orientacion = 0;
    // switch(this.ANGULO_ORIENTACION) {
    // case 0:
    //     orientacion = 0; // 0º
    //     break;

    // case 90:
    //     orientacion = Math.PI / 2; // 90º
    //     break;

    // case 180:
    //     orientacion = Math.PI; // 180º
    //     break;

    // case 270:
    //     orientacion = Math.PI + Math.PI / 2; // 270ª
    //     break;
    // }

    // Pisado solo para desarrollo
    // orientacion = Math.PI / 2; // 90º

    // Cálculo de ángulo en radianes
    radianes = Math.atan2(pto1.y - pto0.y, pto1.x - pto0.x);

    // console.log('Radianes', radianes);

    // Se rota el ángulo en sentido horario en 90 grados
    // 0º es el norte
    // NOTA: añadiendo al ángulo hará que se rote en sentido horario,
    // restado produce el efecto contrario (duh!)
    // PI = 180º

    radianes += Math.PI / 2; // 90º
    // console.log('Radianes', radianes);

    // Conversión de radianes a grados
    // esto devuelve ángulos desde 0 a 270 y de -180 a 0
    angulo = Math.round(radianes * (180 / Math.PI));

    // console.log('Ángulo original', angulo);

    // Corrección para trabajar con ángulos positivos
    if (angulo < 0) {
      angulo += 360;
    }

    return angulo;
  }

  private async showPopupCambioPiso(acceso, cambio, pause = 3000): Promise<void> {
    // const textoCambio = cambio === 'up' ? 'suba por' : 'baje por';
    const response = await this.totemService.getTipoAccesos().toPromise();
    const tipoAcceso = response.find((item) => {
      return item.id_tipo_acceso === acceso.acceso;
    });

    let piso = acceso.numero_piso;
    const direccion = { instruccion: '', img: '' };
    // console.log('tipo de acceso id bli',tipoAcceso.id_tipo_acceso);
    // direccion.instruccion = textoCambio + ' ' + tipoAcceso.nombre_tipo_acceso + ' al siguiente piso';
    console.log('el tipo de acceso',tipoAcceso);
    if (tipoAcceso.nombre_tipo_acceso === "Escalera") {
      // Escalera
      if (cambio === 'up') {
        piso += 1;
        piso = piso.toString();
        direccion.instruccion = 'subirNivel_' + piso;
        direccion.img = 'assets/img/escaleras-front.png';
      } else {
        piso -= 1;
        piso = piso.toString();
        if (piso === '0') {
          piso = '-1';
        }

        direccion.instruccion = 'bajarNivel_' + piso;
        direccion.img = 'assets/img/escaleras-front.png';
      }
    } else if (tipoAcceso.nombre_tipo_acceso === "Escalera" || tipoAcceso.nombre_tipo_acceso === "Rampa") {
      // Escalera Mecánica
      if (cambio === 'up') {
        piso += 1;
        piso = piso.toString();
        direccion.instruccion = 'subirNivel_' + piso;
        direccion.img = 'assets/img/ic-esc-mec-front.png';
      } else {
        piso -= 1;
        piso = piso.toString();
        if (piso === '0') {
          piso = '-1';
        }
        direccion.instruccion = 'bajarNivel_' + piso;
        direccion.img = 'assets/img/ic-esc-mec-front.png';
      }
    } else if (tipoAcceso.nombre_tipo_acceso === "Ascensor") {
      // Ascensor
      if (cambio === 'up') {
        piso += 1;
        direccion.instruccion = 'subirNivel_' + piso;
        direccion.img = 'assets/img/ic-ascensor-front.png';
      } else {
        piso -= 1;
        direccion.instruccion = 'bajarNivel_' + piso;
        direccion.img = 'assets/img/ic-ascensor-front.png';
      }
    }
    if (direccion.instruccion !== null) {
      this.addInstruction(direccion);
    }
    // $('.popup-bg .popup-level img').attr('src', direccion.img);
    // $('.popup-bg .popup-level .text-level').html('<p>' + cambio + ' ' + tipoAcceso.nombre_tipo_acceso + ' siguiente piso');
    // $('.popup-bg').velocity('fadeIn');
    // $('.popup-bg .popup-level').velocity('transition.fadeIn');

    console.log('el acceso', tipoAcceso);
    console.log('nodo totem',acceso);
    acceso.nod_id=acceso.acceso;
    acceso.posicionx = acceso.point.x;
    acceso.posiciony = acceso.point.y;
    let pin =
          '<div  class="talk-bubble tri-right round btm-left no-visible" id="acceso-' + acceso.nod_id + '">';
    pin += '<img id="acceso-' + acceso.nod_id + '" data-id="' + acceso.nod_id + '" src="' + tipoAcceso.imagen_tipo_acceso + '"></div>';

        const bounces = 1;
        // console.log('datos',acceso, pin, bounces)
    // await this.showPin(acceso, pin, bounces);

    // await this.delay(pause);
    return;

  }

  private hidePopupCambioPiso() {
    return new Promise((resolve, reject) => {
      $('.popup-bg').velocity('reverse');
      resolve();
      // $('.popup-bg .popup-level').velocity('transition.fadeOut', {
      //   complete: () => {
      //     $('.popup-bg').css('display', 'none');
      //     $('.popup-bg .popup-level img').attr('src', '');
      //     $('.popup-bg .popup-level .text-level').html('');
      //     console.log('HIDE POP UP');
      //     resolve();
      //   }
      // });
    });
  }

  public setMode(mode) {
    this.propiedadesMapa.modo = mode;
  }

  private moveMapArrow(x, y) {
    if (this.mapArrow != null) {
      this.mapArrow.position.x = x;
      this.mapArrow.position.y = y;
    }
  }

  private addInstruction(direccion) {
    this.ListaInstrucciones.push({a: direccion.instruccion, b: direccion.img});
    if ($('.instrucions-ways .instrucciones li').length === 3) {
      $('.instrucions-ways .instrucciones li:first').remove();
    }

    $('.instrucions-ways .instrucciones').append(
      $('<li>')
          .append($('<span>').text($('.instrucciones li').length))
          .text(direccion.instruccion)
          .append($('<img>').attr('src', direccion.img))
          .css('display', 'none')
      );

    $('.instrucions-ways .instrucciones li:last')
      .velocity('transition.slideLeftBigIn', { duration: 500 });
  }

  cleanInstructions() {
    this.ListaInstrucciones = [];
    // Limpia instrucciones
    $('.instrucions-ways .instrucciones li').velocity('transition.fadeOut', {
      complete: () => {
        $('.instrucions-ways .instrucciones li').remove();
      }
    });
  }

  private getRealImgSize(src: string): Promise<{ width: number, height: number }> {
    const size = { width: 0, height: 0 };

    return new Promise((resolve, reject) => {

      $('<img/>') // Make in memory copy of image to avoid css issues
      .attr('src', src)
      .on('load', (evt) => {
        size.width  = evt.target.width;
        size.height = evt.target.height;
        resolve(size);
      })
      .on('error', (err) => reject(err));
    });
  }

  private async removeMapArrow(): Promise<void> {
    console.log('map arrow',this.mapArrow);
    let opacity = this.mapArrow.opacity;

    for (let i = 0; i < 1; i += .1) {
      // console.log('[I]', i);
      opacity -= .1;
      if (opacity > 0) {
        this.mapArrow.set({ opacity });
      } else {
        this.mapArrow.remove();
        this.mapArrow = null;
      }
      await this.delay(i * 50);
    }
  }

  private delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  public getrutaActiva(){
    return this.propiedadesMapa.rutaActiva;
  }


}
